module.exports = __webpack_public_path__ + "static/VT-57c41b3d683a7d1aca697cf357acfdf1.svg";